import renting_config from "@/components/Renting/config";

export default {
  storeNamespace: 'shipping',
  authFeature: 'shipping',
  listRouteName: "ShippingList",
  newRouteName: "ShippingNew",
  editRouteName: "ShippingEdit",
  detailRouteName: "ShippingDetail",
  hideActionNewButton: true,
  useEditModal: true,
  formComponentName: 'ShippingForm',
  csvExportFilenamePrefix: 'expeditions',
  titleField: 'shipping_number',
  sortBy: 'id',
  sortDesc: true,
  showExtendedFilters: true,
  fields: [
    // Liste
    {
      name: 'shipping_number',
      label: "Code interne",
      type: 'text',
      inList: true,
      sortable: true,
      filterIn: true,
    },
    {
      name: 'renting_number',
      label: "Commande",
      type: 'text',
      inList: true,
      inCsvExport: true,
      filterIn: true,
      formatter: (context, value, item) => item && item.renting_preparation && item.renting_preparation.renting && item.renting_preparation.renting.renting_number ? item.renting_preparation.renting.renting_number : null
    },
    {
      name: 'shipping_date',
      label: "Date d'expédition",
      type: 'date',
      inList: true,
      sortable: true,
      extendedFilter: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD-MM-YYYY") : null
    },
    {
      name: 'business',
      label: "Affaire",
      type: 'text',
      inList: true,
      sortable: true,
      filterIn: true,
      formatter: (context, value, item) => item && item.renting_preparation && item.renting_preparation.renting && item.renting_preparation.renting.business && item.renting_preparation.renting.business.number && item.renting_preparation.renting.business.name ? item.renting_preparation.renting.business.number + ' - ' + item.renting_preparation.renting.business.name : null
    },
    {
      name: 'imputation_number',
      label: "Numéro d'imputation",
      type: 'text',
      inList: true,
      sortable: true,
      filterIn: true,
    },
    {
      name: 'destination',
      label: "Destination",
      type: 'text',
      inList: true,
      sortable: true,
      filterIn: true,
      formatter: (context, value, item) => item && item.renting_preparation && item.renting_preparation.renting && item.renting_preparation.renting.city && item.renting_preparation.renting.zip_code ? item.renting_preparation.renting.city + ' (' + item.renting_preparation.renting.zip_code.substr(0, 2) + ')' : null
    },
    {
      name: 'handling_unit',
      label: "Nombre d'unités de manutention",
      type: 'number',
      inList: true,
      filterIn: false,
    },
    {
      name: 'weight',
      label: "Poids",
      type: 'number',
      step: 0.01,
      inList: true,
      formatter: (context, value) => value ? value + 'Kg' : null
    },
    {
      name: 'shipper',
      label: "Transporteur",
      type: 'text',
      inList: true,
      sortable: true,
      filterIn: true,
      formatter: (context, value) => value && value.name ? value.name : null
    },
    {
      name: 'tracking_number',
      label: "Numéro de suivi",
      type: 'text',
      inList: true,
      sortable: true,
      filterIn: true,
    },
    {
      name: 'refs_and_products',
      label: "Références et produits",
      inList: true,
      filterIn: true,
      formatter: (context, value, item) => {
        var list = []
        if (item.renting_preparation) {
          if (item.renting_preparation.unique_references) {
            item.renting_preparation.unique_references.forEach((unique_references) => {
              list.push(unique_references.internal_code + ' - ' + unique_references.product.name)
            })
          }
          if (item.renting_preparation.products) {
            item.renting_preparation.products.forEach((product) => {
              if(product.product.type == 'selling'){
                list.push(product.product.internal_code + ' - ' + product.product.name)
              }
            })
          }
        }

        if (list) {
          return list.join("<br>")
        } else {
          return null
        }
      }
    },
    {
      name: 'group_slugs',
      label: "Services",
      type: 'select',
      inList: true,
    },
    {
      // 14.16 : filtre entrepôt responsable de l'expédition (select dans "Plus d'options")
      name: 'warehouse',
      label: "Entrepôt",
      type: 'select',
      extendedFilter: true,
    },
    {
      // Filtre seul : origine de l'expédition, via createdBy (NULL = reprise MCS).
      name: 'from_mcs',
      label: "Origine",
      type: 'select',
      inForm: false,
      inList: false,
      inDetail: false,
      inCsvExport: false,
      inPdfExport: false,
      extendedFilter: true,
    },
    // Form et autre
    {
      name: 'shipping_number',
      label: "Code interne",
      type: 'text',
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
    },
    {
      name: 'warehouse_id',
      label: "Entrepôt",
      type: 'select',
      inForm: true,
      required: true,
      inList: false,
      inDetail: false,
      inCsvExport: false,
      inPdfExport: false,
    },
    {
      name: 'warehouse',
      label: "Entrepôt",
      type: 'text',
      inDetail: true,
      detailLink: 'WarehouseDetail',
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value) => value && value.name ? value.name : null
    },
    {
      name: 'shipping_date',
      label: "Date d'expédition",
      type: 'date',
      inForm: true,
      requiredCondition: (form) => form.status_slug != 'shipping-en-preparation',
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD-MM-YYYY") : null
    },
    {
      name: 'geo_area',
      label: "Zone géographique",
      type: 'text',
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
    },
    {
      name: 'shipper_id',
      label: "Transporteur",
      type: 'select',
      inForm: true,
      requiredCondition: (form) => form.status_slug != 'shipping-en-preparation',
      inList: false,
      inDetail: false,
      inCsvExport: false,
      inPdfExport: false,
    },
    {
      name: 'shipper',
      label: "Transporteur",
      type: 'select',
      inForm: false,
      inDetail: true,
      detailLink: 'CompanyDetail',
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value) => value && value.name ? value.name : null
    },
    {
      name: 'tracking_number',
      label: "Numéro de suivi",
      type: 'text',
      inForm: true,
      requiredCondition: (form) => form.status_slug != 'shipping-en-preparation',
      inList: false,
      filterIn: false,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
    },
    {
      name: 'weight',
      label: "Poids",
      type: 'number',
      step: 0.01,
      inDetail: true,
      inPdfExport: true,
      formatter: (context, value) => value ? value + 'Kg' : null
    },
    {
      name: 'weight',
      label: "Poids (Kg)",
      type: 'number',
      step: 0.01,
      inForm: true,
      required: true,
      inCsvExport: true,
    },
    {
      name: 'handling_unit',
      label: "Nombre d'unités de manutention",
      type: 'number',
      inForm: true,
      required: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
    },
    {
      name: 'imputation_number',
      label: "Numéro d'imputation",
      type: 'text',
      inForm: true,
      required: true,
      inList: false,
      filterIn: false,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
    },
    {
      name: 'status_slug',
      label: "Statut",
      type: 'select',
      inForm: true,
      required: true,
      inList: false,
      inDetail: false,
      inCsvExport: false,
      inPdfExport: false,
    },
    {
      name: 'status',
      label: "Statut",
      type: 'select',
      inForm: false,
      tabFilter: true,
      tabFilterDefaultValue: 'shipping-en-attente-de-solution-de-transport',
      key: 'status_slug',
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value) => value && value.name ? value.name : null
    },
    {
      name: 'comment',
      label: "remarques",
      type: 'textarea',
      inForm: true,
      required: false,
      inList: false,
      filterIn: false,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
    },
    {
      name: 'refs_and_products',
      label: "Références et produits",
      inCsvExport: true,
      formatter: (context, value, item) => {
        var list = []
        if (item.renting_preparation) {
          if (item.renting_preparation.unique_references) {
            item.renting_preparation.unique_references.forEach((unique_references) => {
              list.push(unique_references.internal_code + ' - ' + unique_references.product.name)
            })
          }
          if (item.renting_preparation.products) {
            item.renting_preparation.products.forEach((product) => {
              list.push(product.product.internal_code + ' - ' + product.product.name)
            })
          }
        }

        if (list) {
          return list.join("\r\n")
        } else {
          return null
        }
      }
    },
    {
      name: 'created_at',
      label: "Création",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: true,
      inPdfExport: false,
      formatter: (context, value) => value ? value ? context.$moment(value).format("dddd, DD MMMM YYYY") : null : null
    },
    {
      name: 'updated_at',
      label: "Dernière modification",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: true,
      inPdfExport: false,
      formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
    },
    {
      name: 'created_at',
      label: "Création",
      type: 'date',
      inCsvExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD/MM/YYYY") : null
    },
    {
      name: 'updated_at',
      label: "Dernière modification",
      type: 'date',
      inCsvExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD/MM/YYYY") : null
    },
  ],
  pdf_export_logo: 'axiloc',
  pdf_export_title: function (rawValues, values, context) {
    return "Feuille d'expédition " + values.shipping_number
  },
  pdf_export_link: function (rawValues, values, context) {
    return location.protocol +
      "//" +
      location.hostname +
      (location.port ? ":" + location.port : "") +
      context.$router.resolve({
        name: "ShippingDetail",
        params: {
          id: values.id
        }
      }).href
  },
  pdf_export_custom_main_content: function (rawValues, values, context) {
    return null
  },
  pdf_export_extra_content_before: function (rawValues, values, context) {
    let rentingValues = rawValues.renting_preparation &&
      rawValues.renting_preparation.renting ?
      context.$root.formatData(
        rawValues.renting_preparation.renting,
        renting_config.fields.filter((field) => field.name != 'wished_delivery_date' || (field.name == 'wished_delivery_date' && field.inPdfExport == true)) // Pour éviter le double formattage
      ) : {};

    let extra_content = []
    extra_content.push({
      table: {
        widths: ["*", "*"],
        body: [
          [{
            table: {
              widths: ["*", "*"],
              body: [
                ["Expéditeur :", rawValues.warehouse.name || '-'],
                ["Email :", "logistique.axima@equans.com"],
                [
                  "Préparateur :",
                  rawValues.renting_preparation.preparator &&
                  rawValues.renting_preparation.preparator.firstname ?
                    rawValues.renting_preparation.preparator
                      .firstname +
                    " " +
                    rawValues.renting_preparation.preparator
                      .lastname :
                    "-"
                ]
              ]
            },
            layout: "noBorders"
          },
          {
            table: {
              widths: ["*", "*"],
              body: [
                ["Date d'expédition :", values.shipping_date || '-'],
                ["Téléphone :", "02 40 13 65 42"],
                ["Commande :", rentingValues.renting_number || '-']
              ]
            },
            layout: "noBorders"
          }
          ],
          [{
            table: {
              widths: ["*", "*"],
              body: [
                ["Utilisateur :", values.renting_preparation.renting.employee],
                ["Agence :", rentingValues.agency || '-'],
                ["Chantier :", rentingValues.business_fullname || '-'],
                ["Adresse :", rentingValues.delivery_address || '-'],
                ["Code postal :", rentingValues.zip_code || '-'],
                ["Ville :", rentingValues.city || '-'],
                [
                  "Contact 1 :",
                  rentingValues.first_contact_name && rentingValues.first_contact_phone ? rentingValues.first_contact_name +
                    " " +
                    rentingValues.first_contact_phone : '-'
                ],
                [
                  "Contact 2 :",
                  rentingValues.second_contact_name && rentingValues.second_contact_phone ? rentingValues.second_contact_name +
                    " " +
                    rentingValues.second_contact_phone : '-'
                ]
              ]
            },
            layout: "noBorders",
            colSpan: 2
          }],
          [{
            table: {
              widths: ["*", "*"],
              body: [
                ["Date commande :", rentingValues.axiloc_creation_date || '-'],
              ]
            },
            layout: "noBorders"
          },
          {
            table: {
              widths: ["*", "*"],
              body: [
                ["Livraison souhaitée le :", context.$moment(rentingValues.wished_delivery_date).format("DD-MM-YYYY") || '-'],
              ]
            },
            layout: "noBorders"
          }],
          [{
            table: {
              widths: ["*"],
              body: [
                ["Email demandeur : "+rentingValues.email || rentingValues.asker_email || '-']
              ]
            },
            layout: "noBorders",
            colSpan: 2
          }],
          [{
            table: {
              widths: ["*"],
              body: [
                ["Commentaire : "+(rentingValues.comment || '-')]
              ]
            },
            layout: "noBorders",
            colSpan: 2
          }],
          [{
            table: {
              widths: ["*", "*"],
              body: [
                ["Transporteur :", rawValues.shipper ? rawValues.shipper.name : '-'],
                [
                  "Nombre d'unités de manutention :",
                  rawValues.handling_unit || '-'
                ],
                ["Poids :", rawValues.weight ? rawValues.weight + "Kg" : '-'],
                ["Numéro de suivi :", rawValues.tracking_number ? {
                  text: rawValues.tracking_number,
                  link: rawValues.shipper.tracking_link ? rawValues.shipper.tracking_link + rawValues.tracking_number : null,
                } : '-']
              ],

            },
            layout: "noBorders",
            colSpan: 2,
          }]
        ]
      },
      layout: "lightHorizontalLines"
    })

    extra_content.push({ text: 'Produits / matériels dans ce colis', fontSize: 14, bold: true, margin: [0, 10, 0, 10 ], color: '#1AAE7C' });

    if(rawValues.renting_preparation.hasOwnProperty('unique_references') && rawValues.renting_preparation.unique_references.length > 0){
      // références uniques
      let references_list = {
        infos: [
          ["Matériels à la location", "Référence"]
        ]
      };

      // boucles références uniques
      rawValues.renting_preparation.unique_references.forEach(unique_reference => {
        references_list.infos.push([
          unique_reference.product.name,
          unique_reference.internal_code
        ]);
      });

      // insertion des références uniques
      extra_content.push({
        table: {
          widths: ["*", "*"],
          body: references_list.infos
        },
        layout: 'lightHorizontalLines'
      })
    }


    // produits à la vente
    let prepared_products = rawValues.renting_preparation.products.filter(product => product.prepared == true)

    if(prepared_products.length > 0){

      let products_list = {
        infos: [
          ["Produits à la vente", "Quantité"]
        ]
      };

      // boucles produits à la vente
      prepared_products.forEach(product => {
        products_list.infos.push([
          product.product.name,
          product.quantity
        ]);
      });

      // insertion des produits à la vente
      extra_content.push({
        table: {
          widths: ["*", "*"],
          body: products_list.infos
        },
        layout: 'lightHorizontalLines',
        margin: [0, 0, 0, 10]
      })
    }

    if(rawValues.renting_preparation.hasOwnProperty('products_not_sent') && rawValues.renting_preparation.products_not_sent.length > 0){
      extra_content.push({ text: 'Autres produits / matériels commandés', fontSize: 14, bold: true, margin: [0, 40, 0, 10 ], color: '#1AAE7C' });
      extra_content.push({ text: 'Les matériels suivants vous seront adressés via une expédition complémentaire.', margin: [0, 0, 0, 10 ]});
      
      let next_products_list = {
        infos: [
          ["Produits / Matériels", "Quantité"]
        ]
      };

      if(rawValues.renting_preparation.hasOwnProperty('products_not_sent') && rawValues.renting_preparation.products_not_sent.filter(product => product.type == 'renting').length > 0){

        // boucles produits à la loc
        rawValues.renting_preparation.products_not_sent.filter(product => product.type == 'renting').forEach(product => {
          next_products_list.infos.push([
            product.name,
            product.quantity
          ]);
        });
      }


      if(rawValues.renting_preparation.hasOwnProperty('products_not_sent') && rawValues.renting_preparation.products_not_sent.filter(product => product.type == 'selling').length > 0){

        // boucles produits à la vente
        rawValues.renting_preparation.products_not_sent.filter(product => product.type == 'selling').forEach(product => {
          next_products_list.infos.push([
            product.name,
            product.quantity
          ]);
        });
      }

      // insertion des produits
      extra_content.push({
        table: {
          widths: ["*", "*"],
          body: next_products_list.infos
        },
        layout: 'lightHorizontalLines'
      })
    }
    return extra_content
  },
  pdf_export_extra_content_after: function (rawValues, values) {
    let extra_content = []
    extra_content.push({
      table: {
        widths: ["*", "*"],
        body: [
          ["Commentaire : "+(values.comment || '-'),
            {
              table: {
                widths: ["*"],
                body: [
                  [[{
                    text: ["Nom et visa réceptionnaire* :"],
                    fontSize: 12,
                    bold: true
                  }, {
                    text: "* En cas de remise en main propre",
                    fontSize: 8,
                    margin: [0, 0, 0, 50]
                  }]]
                ]
              }
            }
          ]
        ],

      },
      layout: "noBorders",
      margin: [0, 80, 0, 0]
    })
    return extra_content
  },
}



// WEBPACK FOOTER //
// ./src/components/Shipping/config.js